export default {
  secondaryNav: [],
  mainContent: [],
  footerContent: [],
}



// WEBPACK FOOTER //
// ./services/cms-state/helper/initial-state.js